// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@adl/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { DataTableProps } from "@insite/mobius/DataTable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

interface MyAccountOrderListTableStyle {
    dataTable?: DataTableProps;
}

const xOrderListTableStyle: MyAccountOrderListTableStyle = {
    dataTable: {
        css: css`
            margin-bottom: 12px;
            td[class^="DataTableCellBase"] {
                &:empty,
                & > ${TypographyStyle} {
                    ${xOrderInformationStyles.value}
                }
            }
        `,
    },
};

export default xOrderListTableStyle;
